import { useEffect } from 'react';

import { useInView } from 'react-intersection-observer';

import { useTrackOnce } from '#src/app/shared/hooks/tracking';

export function useAiSummaryImpression(petitionId: string, enabled: boolean) {
	const trackOnce = useTrackOnce([petitionId]);
	const { ref, inView } = useInView({ skip: !enabled });

	useEffect(() => {
		if (!enabled || !inView) return;
		void trackOnce('petition_ai_summary_impression', { petition_id: petitionId });
	}, [enabled, inView, petitionId, trackOnce]);

	return ref;
}
